import React from 'react';

import { SectionWithTitle } from './base/Section';
import { InfoRow } from './base/InfoRow';
import { PremiumPricingSectionProps } from './types';

export const PremiumPricingSection: React.FC<PremiumPricingSectionProps> = ({
  totalAmount,
  totalPremiumAmount,
  totalTaxAmount,
  totalTaxAndFeeAmount,
}) => {
  return (
    <SectionWithTitle title="Total Premium">
      <InfoRow label="6-month Premium" value={totalPremiumAmount} />
      {totalTaxAndFeeAmount && (
        <InfoRow
          label={`Fees ${totalTaxAmount ? ' \u0026 Taxes' : ''}`}
          value={totalTaxAndFeeAmount}
        />
      )}
      <InfoRow
        label="Total Term Cost"
        value={totalAmount}
        boldLabel
        boldValue
      />
    </SectionWithTitle>
  );
};
